import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogActions, Grid } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import NewUsersGroup from "./components/NewUsersGroup";
import UsersGroups from "./components/UsersGroups";

function ManageUserGroup() {
  const { direction } = useTheme();
  const [openDialog, setOpenDialog] = useState(false);

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  return (
    <>
      <MuiButton
        color="secondary"
        title={<Translator id="groh_mali_karbaran" />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        fullWidth
        maxWidth="lg"
      >
        <div className="dialogHeader">
          <p> {<Translator id="groh_mali_karbaran" />} </p>
        </div>
        <DialogContent>
          <Grid container spacing={5}>
            <Grid item md={5} sm={6} xs={12}>
              <NewUsersGroup />
            </Grid>
            <Grid item md={7} sm={6} xs={12} className="text-center">
              <UsersGroups />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ManageUserGroup;
